import _ from "lodash";
import store from '../index.js.erb'

import ScholarshipMeetingApi
    from "../../../components/application/scholarship/Services/Api/MeetingApi/ScholarshipMeetingApi";

import {getField, updateField} from "vuex-map-fields";

const ScholarshipMeetingStore = {

    namespaced: true,

    state: ()=>({

        meeting: {

        },

        payload: {

        },

        meetings: [],

        sendSnackbar: false,
    }),

    getters: {
        getPayloadMeeting(state) {
            return getField(state.payload);
        },

        completeStatements(state) {
            if (_.isEmpty(state.meeting)) return []
            const statements = store.state.scholarship_competition.statements;
            if (_.isEmpty(statements)) return []

            return _.filter(statements, statement => state.meeting.completed_statements.includes(statement.id))
        },

        isEmptyMeeting(state) {
            if (_.isEmpty(state.meeting)) return true;

            const meeting = _.cloneDeep(state.meeting)

            return(
              _.isNil(meeting.chairman) ||
              _.isNil(meeting.secretary) ||
              _.isEmpty(meeting.listeners)
            )
        }

    },

    mutations: {
        updatePayloadMeeting(state, field) {
            updateField(state.payload, field);
        },

        setMeetings(state, response) {
            state.meetings = response;
        },

        setMeeting(state, response) {
            state.meeting = response;
        },

        spliceListeners(state, deletedListener) {
            const listeners = state.payload.listeners
            listeners.splice(_.findIndex(listeners, (listener) => listener.id === deletedListener.id), 1)
        },

        setSendSnackbar(state, flag) {
            state.sendSnackbar = flag;
        },

        setPayloadMeeting(state) {
            const meeting = _.cloneDeep(state.meeting);
            state.payload = {
                chairman: meeting.chairman,
                secretary: meeting.secretary,
                meeting_date: meeting.meeting_date,
                number_seats_available: meeting.number_seats_available,
                student_chairman_asset: meeting.student_chairman_asset,
                listeners: meeting.listeners,
            }
        },

        resetPayloadMeeting(state) {
          state.payload = {};
        },
    },

    actions: {
        async getMeetings({commit}) {
            const response = await ScholarshipMeetingApi.index();
            if(_.isNil(response)) return;

            commit("setMeetings", response.data.meetings);
        },

        async getMeeting({commit}, id) {
            const response = await ScholarshipMeetingApi.show(id);
            if(_.isNil(response)) return;2

            commit("setMeeting", response.data.meeting);
        },

        async updateMeeting({state, commit}, payload) {
            const response = await ScholarshipMeetingApi.update(state.meeting.id, payload);
            if(_.isNil(response)) return;

            commit("setMeeting", response.data.meeting);
            commit('setSendSnackbar', true);
        },
    },
}

export default ScholarshipMeetingStore